import React, { FC } from "react";
import "./textInputWithIcon.scss";

interface TextInputWithIconProps {
  value: string;
  setValue: (str: string) => void;
  placeholder: string;
  Icon: any;
  label?: string;
  inputName: string;
  errors?: Record<string, string[]>;
  filedCorrect?: boolean;
  extraStyles?: React.CSSProperties;
  disabled?: boolean;
  onClick?: () => void;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void; // Allow external change handlers
  autoFocus?: boolean;
}

const TextInputWithIcon: FC<TextInputWithIconProps> = ({
  onClick,
  disabled,
  extraStyles,
  filedCorrect,
  errors,
  inputName,
  label,
  Icon,
  placeholder,
  setValue,
  value,
  onChange,
  autoFocus,
}) => {
  return (
    <div onClick={onClick} className={`text-input-with-icon-main-wrapper`}>
      {label && <p className="label">{label}</p>}
      <div
        style={extraStyles}
        className={`text-input-with-icon-main-container  
                    ${
                      filedCorrect !== undefined &&
                      (filedCorrect ? "correct" : "wrong")
                    }`}
      >
        <div className="icon-container flex-center">
          <Icon />
        </div>
        <input
          autoFocus={autoFocus}
          onChange={(e) => {
            setValue(e.target.value);
            if (onChange) onChange(e);
          }}
          value={value}
          placeholder={placeholder}
          type="text"
          className="input-container"
          disabled={disabled}
        />
      </div>

      {errors?.[inputName] &&
        errors[inputName].map((val, index) => (
          <span key={index} className="error-text">
            {" " + val + " "}
          </span>
        ))}
    </div>
  );
};

export default TextInputWithIcon;
